export enum ThumbnailType {
    Icon = 0,
    Card = 1,
    OpenGraph = 2,
};

export type ThumbnailConfiguration = {
    id: ThumbnailType;
    width: number;
    height: number;
    alpha?: number;
}

export const THUMBNAIL_CONFIGURATIONS: { [key in ThumbnailType]: ThumbnailConfiguration } = {
    [ThumbnailType.Icon]: {
        id: ThumbnailType.Icon,
        width: 128,
        height: 128,
    },
    [ThumbnailType.Card]: {
        id: ThumbnailType.Card,
        width: 480,
        height: 480,
        alpha: 0.15,
    },
    [ThumbnailType.OpenGraph]: {
        id: ThumbnailType.OpenGraph,
        width: 1200,
        height: 630,
    },
};

export function getThumbnailConfigForType(type: ThumbnailType): ThumbnailConfiguration {
    const config = THUMBNAIL_CONFIGURATIONS[type];

    if (!config) {
        throw new Error(`Thumbnail type ${type} does not exist`);
    }

    return config;
}
